// ページごとに読み込まれるファイル
// Must use "const" or "var"
const imagesLoaded = require('imagesloaded')
const velocity = require('velocity-animate')
const flipclock = require('../vendor/flipclock.min.js')
const YouTubePlayer = require('youtube-player');


export default class Index {
  constructor(id) {
    this.id = id
    require.ensure(['jquery','imagesloaded'], ()=> {
      this.initialize()
    });
  }

  initialize() {
    let self = this;
    this.setPlayer()
    this.setCountdown()

    this.sample_imagesloaded()
    this.sample_message()
    this.sample_velocity()

    // init
    $(window).resize(function() {
      if($('#cover').length){
        self.setPlayer()
      }
    });
  }

  // methods
  sample_imagesloaded(){
    imagesLoaded('#main', ()=>{
      console.log('loaded');
    });
  }

  sample_message(){
    const message = require('../async/message.js')
    console.log(message(`${this.id}.js loaded`));
  }

  sample_velocity(){
    const $article = $('.m-list-article')
    $article.on('mouseenter', (e)=> {
      const $el = $(e.currentTarget).find('img')
      $el.velocity({
        // 'scale': 1.1
      }, {
        easing: 'easeOutQuart',
        duration: 500
      })
    })
    $article.on('mouseleave', (e)=> {
      const $el = $(e.currentTarget).find('img')
      $el.velocity({
        'scale': 1
      }, {
        easing: 'easeOutQuart',
        duration: 500
      })
    })
  }

  setCountdown() {
    var countdown;
    var clocks = new Array();
    $('.countdown').each(function(){
       var time = $(this).data("countdown");
       time = ((new Date(time)) - (new Date().getTime())) / 1000;
       var clock = $(this).FlipClock(time, {
           countdown: true,
           clockFace: 'DailyCounter',
       });
       clocks.push(clock);
     });
  }


  setPlayer() {
    const playerCover = document.getElementById('player_cover');
    if(playerCover === null) return

    if(window.getComputedStyle(playerCover).display === 'none') {
      const imagePath = $('#cover .image').attr("data-image");
      $('#cover .image').css('background-image', `url(${imagePath})`);
    } else {
      const videoId = playerCover.getAttribute("data-movie").split('/')[4];

      const player = YouTubePlayer('cover-background-movie', {
        playerVars: {
          'autoplay': 1,
          'controls': 0,
          'autohide': 1,
          'wmode': 'opaque',
          'showinfo': 0,
          'loop': 1,
          'playlist' : videoId,
          'rel': 0,
          'mute': 1,
          'start': 0,
          'end': 96
        },
        videoId
      });

      player
        .playVideo()
        .then(function () {
          const width = $(document).width();
          const height = width / 16 * 9;
          $('#cover-background-movie').css({'height': `${height}px`});
        });
    }
  }
}



// WEBPACK FOOTER //
// ./pages/home.js